import React, { useEffect, useState } from "react";
import TableComponent from "../TableComponent/TableComponent.jsx";
import './FeatureRequests.css';
import Tabs from '../SegmentBar/TabBar';
import { useNavigate, useLocation } from "react-router-dom";
import { fetchAnalyticsProd } from "../services/FirebaseService.js"; // Import the centralized function



function FeatureRequests() {
    const navigate = useNavigate(); // Define navigate at the top level
    const location = useLocation();
    const [featureRequestsData, setData] = useState([]); // State to hold the table data
    const [activeIndex, setActiveIndex] = useState(1);

    const handleTabSelect = (index) => {
        console.log(`Selected Tab: ${index}`);
            const paths = ["/user-feedbacks", "/feature-requests", "/reported-issues"];
            setActiveIndex(index); // Update the active index
            if (index != 1) {
                navigate(paths[index]); // Navigate to the selected route
            }
            
    };

    useEffect(() => {
        const fetchData = async () => {
                    try {
                        const featureRequestsData = await fetchAnalyticsProd("Feature Requests/PROD"); // Fetch data
                        var sorted_data = featureRequestsData.sort((a,b) => {
                            return new Date(a.timestamp).getTime() - 
                                new Date(b.timestamp).getTime()
                        }).reverse();
                        setData(sorted_data); // Update the state with the fetched data
                    } catch (err) {
                        console.error("Error fetching reported issues data:", err);
                    }
                };
                fetchData();
        if (location.pathname === "/user-feedbacks") {
            setActiveIndex(0);
        } else if (location.pathname === "/feature-requests") {
            setActiveIndex(1);
        } else if (location.pathname === "/reported-issues") {
            setActiveIndex(2);
        }
    }, [location.pathname]);

    const columns = React.useMemo(
        () => [
            { Header: "Timestamp", accessor: "timestamp" },
            { Header: "User Requested Feature", accessor: "feature" },
            { Header: "Room for Improvement", accessor: "improvement" },
            { Header: "DHU Firmware Version", accessor: "firmwareVersion" },
            { Header: "Device Serial Number", accessor: "dsn" },
            { Header: "Mobile App Version", accessor: "mobileAppVersion" },
            { Header: "Mobile Model", accessor: "mobileModel" },
            { Header: "Vehicle Model", accessor: "vehicleModel" },
            { Header: "Vehicle Serial", accessor: "vehicleSerial" },
            { Header: "User ID", accessor: "userId" },
        ],
        []
    );

    return (
        <div className="FeatureRequests">
            <div className="tab-container">
                <Tabs
                    tabs={["LDC Feedbacks","Feature Requests", "Reported Issues"]}
                    activeIndex={1}
                    onTabSelect={handleTabSelect}
                />
            </div>
            <div className="feature-content">
            <div className="BodyFeatureRequest">
                Featured Requests
            </div>
            </div>
            {featureRequestsData.length === 0 ? (
                <div className="no-feedback-message">
                    No Feature Requests submitted by the users.
                </div>
            ) : (
                    <TableComponent columns={columns} data={featureRequestsData} />
            )}
        </div>
    );
}

export default FeatureRequests;
